<template>
  <div>
    <div v-if="!loading">
      <div class="font-weight-bold pa-0 mt-4">Shipping Details</div>
      <v-select
        dense
        v-model="selectedShippingInstructions"
        :items="getShippingInstructions"
        item-text="name"
        item-value="id"
        label="Shipping Instructions"
        single-line
        return-object
        :rules="requireObjectField"
        :hint="
          (selectedShippingInstructions &&
            selectedShippingInstructions.description) ||
          ``
        "
        :persistent-hint="true"
      >
        <template slot="append-outer">
          <v-tooltip class="mr-0" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on">
                mdi-help-circle-outline
              </v-icon>
            </template>
            <ul v-for="(item, i) in getShippingInstructions" :key="i">
              <li>{{ item.name }}: {{ item.description }}</li>
            </ul>
          </v-tooltip>
        </template>
      </v-select>
    </div>
    <v-progress-linear
      class="mt-4 mb-4"
      indeterminate
      v-else
    ></v-progress-linear>
  </div>
</template>

<script>
import orderMixin from '@/mixins/order'
import {mapGetters} from 'vuex'
import {get} from 'lodash'

export default {
  mixins: [orderMixin],
  props: ['buySell', 'companyId'],
  data() {
    return {
      loading: true,
    }
  },
  watch: {
    companyId: {
      handler() {
        this.init()
      },
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      if (!get(this, `selectedShippingInstructions.id`)) {
        await this.$store.dispatch('fetchShippingInstructions')
        const shippingInstructions = this.getShippingInstructions
        const match = shippingInstructions.filter((x) => {
          if (this.getSelectedCompany.defaultShippingInstructionId)
            return this.getSelectedCompany.defaultShippingInstructionId === x.id
          else return parseInt(x.netsuite_internalId) === 1
        })
        if (match[0]) {
          this.selectedShippingInstructions = match[0]
        }
      }
      this.$emit('loaded')
      this.loading = false
    },
  },
  computed: {
    ...mapGetters([
      'getSelectedCompany',
      'getDefaultShippingAddress',
      'getShippingInstructions',
    ]),
    selectedShippingInstructions: {
      get() {
        return this.$store.getters['getCartField'](
          `${this.buySell}.selectedShippingInstructions`
        )
      },
      set(value) {
        this.$store.commit('updateCartField', {
          path: `${this.buySell}.selectedShippingInstructions`,
          value,
        })
        if (
          parseInt(value.netsuite_internalId) ===
          this.HOLD_FOR_INSTRUCTIONS_NS_ID
        ) {
          this.selectedShippingAddress = this.noShippingAddressRequired
        } else if (!get(this, `selectedShippingAddress.id`)) {
          this.selectedShippingAddress = this.getDefaultShippingAddress
        }
      },
    },
    selectedShippingAddress: {
      get() {
        return this.$store.getters['getCartField'](
          `${this.buySell}.selectedShippingAddress`
        )
      },
      set(value) {
        this.$store.commit('updateCartField', {
          path: `${this.buySell}.selectedShippingAddress`,
          value,
        })
      },
    },
  },
}
</script>
